import { render, staticRenderFns } from "./maintenance-detail.vue?vue&type=template&id=2d08ae41&lang=pug"
import script from "./maintenance-detail.vue?vue&type=script&lang=js"
export * from "./maintenance-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports